import { dateSort, projNumSort } from '../../utilities/services/sortConditionally';
import PatentApplicationsListItem from '../PatentApplicationsListItem/PatentApplicationsListItem';
import './PatentApplicationsList.css';

export default function PatentApplicationsList({user, patentApplications, updatePatentApplications, sortHeader, setSortHeader, sortOrder, setSortOrder, isMobile}) {
    const datesArray = ['earliestPriorityDate', 'filingDate', 'plannedFilingDate', 'officialFilingDate', 'nationalEntryDate', 'publicationDate', 'estimatedFirstOfficeActionDate', 'officialOfficeActionDate', 'allowanceDate', 'examinerInterviewDate', 'RCEFiledDate', 'issueFeePaymentDate', 'issueDate', 'maintenanceFeeDueDate', 'expirationDate', 'abandonedDate']

    const handleTableHeaderClick = (evt) => {
        const header = evt.target.id;
        const newSortOrder = sortOrder === 'asc' ? 'desc' : 'asc'
        setSortHeader(header);
        setSortOrder(newSortOrder);

        let sortedApplications = [...patentApplications];
        if (header === 'RPNumber') {
            sortedApplications = projNumSort(newSortOrder, header, sortedApplications);
        } else if (datesArray.includes(header)) {
            sortedApplications = dateSort(newSortOrder, header, sortedApplications);
        } else {
            sortedApplications.sort((a, b) => {
            if (newSortOrder === 'asc') {
                return ((typeof(a[header])==='string' ? a[header].toLowerCase() : a[header]) > (typeof(b[header])==='string' ? b[header].toLowerCase() : b[header])) ? 1 : -1;
            } else {
                return ((typeof(a[header])==='string' ? a[header].toLowerCase() : a[header]) < (typeof(b[header])==='string' ? b[header].toLowerCase() : b[header])) ? 1 : -1;
            }
            });
        }
        updatePatentApplications(sortedApplications);
    }

    // console.log(patentApplicationPreferences)
  
  
    return (
    <div className='PatentApplicationsList'>
        {patentApplications && patentApplications.length > 0 ?
        <>
        <div className='patentApplicationsTable'>
            <table className=''>
                <thead>
                    <tr>
                        <th id='RPNumber' onClick={handleTableHeaderClick} className='RPNumber'>
                            <div className='tableHeaderWithArrow'><div>RP Number&nbsp;&nbsp;</div>
                                { sortHeader==='RPNumber'?
                                <>
                                {sortOrder==='asc' ?
                                <div>
                                    <div className='sortIndicatorActive'>&#9650;</div>
                                    <div className='sortIndicatorInactive'>&#9660;</div>
                                </div>
                                : 
                                <div>
                                    <div className='sortIndicatorInactive'>&#9650;</div>
                                    <div className='sortIndicatorActive'>&#9660;</div>
                                </div>
                                }
                                </>
                                :
                                <div>
                                    <div className='sortIndicatorInactive'>&#9650;</div>
                                    <div className='sortIndicatorInactive'>&#9660;</div>
                                </div>
                                }
                            </div>
                        </th>
                        <th id='applicationNumber' onClick={handleTableHeaderClick} className='applicationNumber'>
                            <div className='tableHeaderWithArrow'><div>Application Num&nbsp;&nbsp;</div>
                                { sortHeader==='applicationNumber'?
                                <>
                                {sortOrder==='asc' ?
                                <div>
                                    <div className='sortIndicatorActive'>&#9650;</div>
                                    <div className='sortIndicatorInactive'>&#9660;</div>
                                </div>
                                : 
                                <div>
                                    <div className='sortIndicatorInactive'>&#9650;</div>
                                    <div className='sortIndicatorActive'>&#9660;</div>
                                </div>
                                }
                                </>
                                :
                                <div>
                                    <div className='sortIndicatorInactive'>&#9650;</div>
                                    <div className='sortIndicatorInactive'>&#9660;</div>
                                </div>
                                }
                            </div>
                        </th>
                        <th id='applicationType' onClick={handleTableHeaderClick} className='applicationType'>
                            <div className='tableHeaderWithArrow'><div>Application Type&nbsp;&nbsp;</div>
                                { sortHeader==='applicationType'?
                                <>
                                {sortOrder==='asc' ?
                                <div>
                                    <div className='sortIndicatorActive'>&#9650;</div>
                                    <div className='sortIndicatorInactive'>&#9660;</div>
                                </div>
                                : 
                                <div>
                                    <div className='sortIndicatorInactive'>&#9650;</div>
                                    <div className='sortIndicatorActive'>&#9660;</div>
                                </div>
                                }
                                </>
                                :
                                <div>
                                    <div className='sortIndicatorInactive'>&#9650;</div>
                                    <div className='sortIndicatorInactive'>&#9660;</div>
                                </div>
                                }
                            </div>
                        </th>
                        <th id='filingDate' onClick={handleTableHeaderClick} className='filingDate dateField'>
                            <div className='tableHeaderWithArrow'><div>Filing Date&nbsp;&nbsp;</div>
                                { sortHeader==='filingDate'?
                                <>
                                {sortOrder==='asc' ?
                                <div>
                                    <div className='sortIndicatorActive'>&#9650;</div>
                                    <div className='sortIndicatorInactive'>&#9660;</div>
                                </div>
                                : 
                                <div>
                                    <div className='sortIndicatorInactive'>&#9650;</div>
                                    <div className='sortIndicatorActive'>&#9660;</div>
                                </div>
                                }
                                </>
                                :
                                <div>
                                    <div className='sortIndicatorInactive'>&#9650;</div>
                                    <div className='sortIndicatorInactive'>&#9660;</div>
                                </div>
                                }
                            </div>
                        </th>
                        <th id='title' onClick={handleTableHeaderClick} className='title'>
                            <div className='tableHeaderWithArrow'><div>Title&nbsp;&nbsp;</div>
                                { sortHeader==='title'?
                                <>
                                {sortOrder==='asc' ?
                                <div>
                                    <div className='sortIndicatorActive'>&#9650;</div>
                                    <div className='sortIndicatorInactive'>&#9660;</div>
                                </div>
                                : 
                                <div>
                                    <div className='sortIndicatorInactive'>&#9650;</div>
                                    <div className='sortIndicatorActive'>&#9660;</div>
                                </div>
                                }
                                </>
                                :
                                <div>
                                    <div className='sortIndicatorInactive'>&#9650;</div>
                                    <div className='sortIndicatorInactive'>&#9660;</div>
                                </div>
                                }
                            </div>
                        </th>
                        <th id='applicationStatus' onClick={handleTableHeaderClick} className='applicationStatus'>
                            <div className='tableHeaderWithArrow'><div>Application Status&nbsp;&nbsp;</div>
                                { sortHeader==='applicationStatus'?
                                <>
                                {sortOrder==='asc' ?
                                <div>
                                    <div className='sortIndicatorActive'>&#9650;</div>
                                    <div className='sortIndicatorInactive'>&#9660;</div>
                                </div>
                                : 
                                <div>
                                    <div className='sortIndicatorInactive'>&#9650;</div>
                                    <div className='sortIndicatorActive'>&#9660;</div>
                                </div>
                                }
                                </>
                                :
                                <div>
                                    <div className='sortIndicatorInactive'>&#9650;</div>
                                    <div className='sortIndicatorInactive'>&#9660;</div>
                                </div>
                                }
                            </div>
                        </th>
                        <th id='inventors' onClick={handleTableHeaderClick} className='inventors'>
                            <div className='tableHeaderWithArrow'><div>Inventors&nbsp;&nbsp;</div>
                                { sortHeader==='inventors'?
                                <>
                                {sortOrder==='asc' ?
                                <div>
                                    <div className='sortIndicatorActive'>&#9650;</div>
                                    <div className='sortIndicatorInactive'>&#9660;</div>
                                </div>
                                : 
                                <div>
                                    <div className='sortIndicatorInactive'>&#9650;</div>
                                    <div className='sortIndicatorActive'>&#9660;</div>
                                </div>
                                }
                                </>
                                :
                                <div>
                                    <div className='sortIndicatorInactive'>&#9650;</div>
                                    <div className='sortIndicatorInactive'>&#9660;</div>
                                </div>
                                }
                            </div>
                        </th>
                        <th id='country' onClick={handleTableHeaderClick} className='country'>
                            <div className='tableHeaderWithArrow'><div>Country&nbsp;&nbsp;</div>
                                { sortHeader==='country'?
                                <>
                                {sortOrder==='asc' ?
                                <div>
                                    <div className='sortIndicatorActive'>&#9650;</div>
                                    <div className='sortIndicatorInactive'>&#9660;</div>
                                </div>
                                : 
                                <div>
                                    <div className='sortIndicatorInactive'>&#9650;</div>
                                    <div className='sortIndicatorActive'>&#9660;</div>
                                </div>
                                }
                                </>
                                :
                                <div>
                                    <div className='sortIndicatorInactive'>&#9650;</div>
                                    <div className='sortIndicatorInactive'>&#9660;</div>
                                </div>
                                }
                            </div>
                        </th>
                        <th id='patentType' onClick={handleTableHeaderClick} className='patentType'>
                            <div className='tableHeaderWithArrow'><div>Patent Type&nbsp;&nbsp;</div>
                                { sortHeader==='patentType'?
                                <>
                                {sortOrder==='asc' ?
                                <div>
                                    <div className='sortIndicatorActive'>&#9650;</div>
                                    <div className='sortIndicatorInactive'>&#9660;</div>
                                </div>
                                : 
                                <div>
                                    <div className='sortIndicatorInactive'>&#9650;</div>
                                    <div className='sortIndicatorActive'>&#9660;</div>
                                </div>
                                }
                                </>
                                :
                                <div>
                                    <div className='sortIndicatorInactive'>&#9650;</div>
                                    <div className='sortIndicatorInactive'>&#9660;</div>
                                </div>
                                }
                            </div>
                        </th>
                        <th id='earliestPriorityDate' onClick={handleTableHeaderClick} className='earliestPriorityDate dateField'>
                            <div className='tableHeaderWithArrow'><div>Earliest Priority&nbsp;&nbsp;</div>
                                { sortHeader==='earliestPriorityDate'?
                                <>
                                {sortOrder==='asc' ?
                                <div>
                                    <div className='sortIndicatorActive'>&#9650;</div>
                                    <div className='sortIndicatorInactive'>&#9660;</div>
                                </div>
                                : 
                                <div>
                                    <div className='sortIndicatorInactive'>&#9650;</div>
                                    <div className='sortIndicatorActive'>&#9660;</div>
                                </div>
                                }
                                </>
                                :
                                <div>
                                    <div className='sortIndicatorInactive'>&#9650;</div>
                                    <div className='sortIndicatorInactive'>&#9660;</div>
                                </div>
                                }
                            </div>
                        </th>
                        <th id='earliestPriorityApplicationNumber' onClick={handleTableHeaderClick} className='earliestPriorityApplicationNumber'>
                            <div className='tableHeaderWithArrow'><div>Earliest Priority Application Num&nbsp;&nbsp;</div>
                                { sortHeader==='earliestPriorityApplicationNumber'?
                                <>
                                {sortOrder==='asc' ?
                                <div>
                                    <div className='sortIndicatorActive'>&#9650;</div>
                                    <div className='sortIndicatorInactive'>&#9660;</div>
                                </div>
                                : 
                                <div>
                                    <div className='sortIndicatorInactive'>&#9650;</div>
                                    <div className='sortIndicatorActive'>&#9660;</div>
                                </div>
                                }
                                </>
                                :
                                <div>
                                    <div className='sortIndicatorInactive'>&#9650;</div>
                                    <div className='sortIndicatorInactive'>&#9660;</div>
                                </div>
                                }
                            </div>
                        </th>
                        <th id='nextAction' onClick={handleTableHeaderClick} className='nextAction'>
                            <div className='tableHeaderWithArrow'><div>Next Action&nbsp;&nbsp;</div>
                                { sortHeader==='nextAction'?
                                <>
                                {sortOrder==='asc' ?
                                <div>
                                    <div className='sortIndicatorActive'>&#9650;</div>
                                    <div className='sortIndicatorInactive'>&#9660;</div>
                                </div>
                                : 
                                <div>
                                    <div className='sortIndicatorInactive'>&#9650;</div>
                                    <div className='sortIndicatorActive'>&#9660;</div>
                                </div>
                                }
                                </>
                                :
                                <div>
                                    <div className='sortIndicatorInactive'>&#9650;</div>
                                    <div className='sortIndicatorInactive'>&#9660;</div>
                                </div>
                                }
                            </div>
                        </th>
                        <th id='nextActionDueDate' onClick={handleTableHeaderClick} className='nextActionDueDate dateField'>
                            <div className='tableHeaderWithArrow'><div>Next Action Due&nbsp;&nbsp;</div>
                                { sortHeader==='nextAction'?
                                <>
                                {sortOrder==='asc' ?
                                <div>
                                    <div className='sortIndicatorActive'>&#9650;</div>
                                    <div className='sortIndicatorInactive'>&#9660;</div>
                                </div>
                                : 
                                <div>
                                    <div className='sortIndicatorInactive'>&#9650;</div>
                                    <div className='sortIndicatorActive'>&#9660;</div>
                                </div>
                                }
                                </>
                                :
                                <div>
                                    <div className='sortIndicatorInactive'>&#9650;</div>
                                    <div className='sortIndicatorInactive'>&#9660;</div>
                                </div>
                                }
                            </div>
                        </th>
                        <th id='publicationDate' onClick={handleTableHeaderClick} className='publicationDate dateField'>
                            <div className='tableHeaderWithArrow'><div>Publication&nbsp;&nbsp;</div>
                                { sortHeader==='publicationDate'?
                                <>
                                {sortOrder==='asc' ?
                                <div>
                                    <div className='sortIndicatorActive'>&#9650;</div>
                                    <div className='sortIndicatorInactive'>&#9660;</div>
                                </div>
                                : 
                                <div>
                                    <div className='sortIndicatorInactive'>&#9650;</div>
                                    <div className='sortIndicatorActive'>&#9660;</div>
                                </div>
                                }
                                </>
                                :
                                <div>
                                    <div className='sortIndicatorInactive'>&#9650;</div>
                                    <div className='sortIndicatorInactive'>&#9660;</div>
                                </div>
                                }
                            </div>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    { patentApplications.length === 0 ?
                    <tr>
                    <td colSpan='12' className='noApplications text-center'>No Applications Found</td>
                    </tr>
                    :
                    <>
                    {patentApplications.map(application => (
                    <PatentApplicationsListItem user={user} key={application._id} applicationItem={application} isMobile={isMobile} />
                    ))}
                    </>
                    }
                </tbody>
            </table>
        </div>
        <div className='footer'>
          <div>
            page count
          </div>
          <div>
            toggle
          </div>
        </div>
        </>
        :
        <div className='emptyList'>
            <div className='text-center'>
                <h4 className='errorText pt-3'>No Patent Applications</h4>
            </div>
        </div>
        }
    </div>
  )
}
